







import { Component, Vue } from 'vue-property-decorator';
import { wxService } from './services/wx.service';
import { dvService } from './services/device.service';
import Load from './components/Load.vue';
import Confirm from './components/Confirm.vue';
import { pcService } from './services/pc.service';
import { userService } from './services/user.service';
import { switchMap, tap, map } from 'rxjs/operators';
import { of, from } from 'rxjs';
import { lsService } from './services/ls.service';
import { APP_CONFIG } from './config';

@Component({ components: { Load, Confirm } })
export default class App extends Vue {
  wx = dvService.isWX;
  ios = dvService.md.is('ios');
  android = dvService.md.is('AndroidOS');
  mobile = dvService.md.mobile();
  ready: boolean = false;

  /** 给 app 添加对应环境的 classname */
  classList = {
    wx: this.wx,
    ios: this.ios,
    android: this.android,
  };

  loadOver: boolean = false;
  imgList: string[] = this.$store.state.imgs;

  public get user() {
    return this.$store.state.user;
  }

  init() {
    let openId = '';
    let path = '';

    const getRouter = () => {
      path = this.$route.path;
      const query = this.$route.query;

      if (/openid=/.test(this.$route.fullPath)) {
        const params = this.$route.fullPath.match(/.*openid=[^&]+/);
        if (!params) return;
        openId = (query.openid as string) || params[0].replace(/.*openid=/, '');

        let route = path.replace(/[&|?]openid=.*/, '');
        this.$router.replace(route);
      }
    };

    console.log('当前路径和openid', { path, openId, route: this.$route });

    return of(0).pipe(
      switchMap(() => {
        if (openId) return from(lsService.localForage.setItem('openId', openId));
        getRouter();
        return of('');
      }),
      switchMap(() => userService.initStoreData()),
      // 新用户直接进入首页
      tap(res => {
        const name = this.$route.name;
        console.log(name, this.$route);
        if (name === 'Entrance' || name === 'Prize' || name === 'Winlist') return;
        if (!res) this.$router.replace('/');
      }),

      switchMap(() => wxService.getWkOpenId(path, openId)),
      tap(res => console.log('getWkOpenId', res)),
      switchMap(res => userService.initUserData(openId || res)),
      switchMap(res => userService.mergeData(res)),
      tap(() => (this.ready = true)),
    );
  }

  created() {
    /** 获取微信openId */
    // wxService.getWkOpenId().subscribe();
    // this.getUserInfo();

    // of(0)
    //   .pipe(switchMap(() => wxService.getCode()))
    //   .subscribe();
    // lsService.removeUserData();
    document.addEventListener(`WeixinJSBridgeReady`, () => {
      // this.$store.state.bgm.play();
      // this.$store.state.bgm.pause();
      setTimeout(() => {
        const audios = this.$store.state.audios;
        for (const key in audios) {
          if (audios.hasOwnProperty.call(audios, key)) {
            const audio = audios[key];
            audio.play();
            audio.pause();
          }
        }
      }, 200);
    });

    console.log(`history`, history.length, history);
    setTimeout(() => {
      this.init().subscribe();
    }, 200);
  }
}
